/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} VersusInputs */

const th_versus = /** @type {(inputs: VersusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`พบ`)
};

const en_versus = /** @type {(inputs: VersusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vs`)
};

const ja_versus = /** @type {(inputs: VersusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`対`)
};

const zh_versus = /** @type {(inputs: VersusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对阵`)
};

const es_versus = /** @type {(inputs: VersusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`contra`)
};

const pt_versus = /** @type {(inputs: VersusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x`)
};

const id_versus = /** @type {(inputs: VersusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lawan`)
};

const fr_versus = /** @type {(inputs: VersusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`contre`)
};

const tl_versus = /** @type {(inputs: VersusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`laban sa`)
};

const vi_versus = /** @type {(inputs: VersusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gặp`)
};

const ko_versus = /** @type {(inputs: VersusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대`)
};

const de_versus = /** @type {(inputs: VersusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gegen`)
};

const ru_versus = /** @type {(inputs: VersusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`против`)
};

const tr_versus = /** @type {(inputs: VersusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`karşı`)
};

const it_versus = /** @type {(inputs: VersusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`contro`)
};

const pl_versus = /** @type {(inputs: VersusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`przeciwko`)
};

const uk_versus = /** @type {(inputs: VersusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`проти`)
};

const hi_versus = /** @type {(inputs: VersusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बनाम`)
};

const ar_versus = /** @type {(inputs: VersusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ضد`)
};

const ms_versus = /** @type {(inputs: VersusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lawan`)
};

const bn_versus = /** @type {(inputs: VersusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বনাম`)
};

const zh_tw2_versus = /** @type {(inputs: VersusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`對`)
};

const zh_hk2_versus = /** @type {(inputs: VersusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`對`)
};

const ur_versus = /** @type {(inputs: VersusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بمقابلہ`)
};

const fa_versus = /** @type {(inputs: VersusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مقابل`)
};

const sw_versus = /** @type {(inputs: VersusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dhidi ya`)
};

const nl_versus = /** @type {(inputs: VersusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tegen`)
};

/**
* | output |
* | --- |
* | "vs" |
*
* @param {VersusInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const versus = /** @type {((inputs?: VersusInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<VersusInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_versus(inputs)
	if (locale === "ja") return ja_versus(inputs)
	if (locale === "zh") return zh_versus(inputs)
	if (locale === "es") return es_versus(inputs)
	if (locale === "pt") return pt_versus(inputs)
	if (locale === "id") return id_versus(inputs)
	if (locale === "fr") return fr_versus(inputs)
	if (locale === "tl") return tl_versus(inputs)
	if (locale === "vi") return vi_versus(inputs)
	if (locale === "ko") return ko_versus(inputs)
	if (locale === "de") return de_versus(inputs)
	if (locale === "ru") return ru_versus(inputs)
	if (locale === "tr") return tr_versus(inputs)
	if (locale === "it") return it_versus(inputs)
	if (locale === "pl") return pl_versus(inputs)
	if (locale === "uk") return uk_versus(inputs)
	if (locale === "hi") return hi_versus(inputs)
	if (locale === "ar") return ar_versus(inputs)
	if (locale === "ms") return ms_versus(inputs)
	if (locale === "bn") return bn_versus(inputs)
	if (locale === "zh-TW") return zh_tw2_versus(inputs)
	if (locale === "zh-HK") return zh_hk2_versus(inputs)
	if (locale === "ur") return ur_versus(inputs)
	if (locale === "fa") return fa_versus(inputs)
	if (locale === "sw") return sw_versus(inputs)
	if (locale === "nl") return nl_versus(inputs)
	return en_versus(inputs)
});